import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PteMaxRouteGuard = ({ children }) => {
  const institute = useSelector((state) => state.institute);

  if (!institute) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PteMaxRouteGuard;
